import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const GnomesInGardens: Site = {
  id: 'gnomesingardens',
  logo: 'gnomesingardens.png',
  label: 'GnomesInGardens',
  analyticsName: 'gnomesingardens',
  hostname: 'gnomesingardens.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
